import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/endOfWeek/index.js';

var require$$46 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$46 as default };
